import { render, staticRenderFns } from "./gratis.vue?vue&type=template&id=4176c49a"
import script from "./gratis.vue?vue&type=script&lang=js"
export * from "./gratis.vue?vue&type=script&lang=js"
import style0 from "./gratis.vue?vue&type=style&index=0&id=4176c49a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports